export default __webpack_public_path__ + "static/media/Sizzling_bliss_large_8.ea5fc47b.jpg";